import React from 'react';

import { ToggleSwitch } from '../../../../../../components/toggle-switch';

import './styles.scss';

export interface PortfolioRiskSettingsToggleItemProps {
  label: string;
  description: string;
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
  isDisabled?: boolean;
}

export const PortfolioRiskSettingsToggleItem: React.FC<PortfolioRiskSettingsToggleItemProps> = ({
  label,
  description,
  isEnabled,
  onToggle,
  isDisabled = false,
}) => {
  return (
    <div className="portfolio-risk-settings-toggle-item">
      <div
        className={`portfolio-risk-settings-toggle-area ${isDisabled ? 'portfolio-risk-settings-toggle-area-disabled' : ''}`}
      >
        <ToggleSwitch isOn={isEnabled} setIsOn={onToggle} isDisabled={isDisabled} />
        <span>{label}</span>
      </div>
      <span
        className={`portfolio-risk-settings-toggle-item-description ${isDisabled ? 'portfolio-risk-settings-toggle-item-description-disabled' : ''}`}
      >
        {description}
      </span>
    </div>
  );
};
